module.exports = __webpack_public_path__ + "img/feed_gallery.ce972f9a.svg";